export default "__VITE_ASSET__BwjidNLT__"